import React from 'react'; //eslint-disable-line
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Bolt from '../components/BoltIcon';
import * as CONSTS from '../utils/constants';
// import goTrackerConfig from 'goTrackerConfig';
import '../i18n';

const FooterContainer = observer(() => {
  const { t } = useTranslation();
  const location = useLocation();

  //Do not display footer on home page
  if (location.pathname === CONSTS.VIEW_PATHS.HOME) return;

  // eslint-disable-next-line consistent-return
  return (
    <footer className="footer-container">
      <span>
        <span><Bolt /></span>
        <label>{t('footer.express')}</label>
      </span>
      {/* <span>
        <i className="fa fa-chevron-right" />
        <label>{t('footer.tripStops')}</label>
      </span> */}
      {/* {goTrackerConfig.favFeature && (
        <span>
          <i className="fa fa-thumbtack" />
          <label>{t('footer.fav')}</label>
        </span>
      )} */}
    </footer>
  );
});

export default FooterContainer;
